export default __webpack_public_path__ + "static/assets/49991429507c7f0f2d892c81a201a0ef.png";